<template>
  <article>
    <group gutter="0px">
      <cell title="订购车型" primary="content" class="status-left car-info-sel" is-link @click.native="selModel(false)">
        <p v-if="buy.car_model_id" slot="value" class="car-info">{{buy.car_mode_name}}</p>
        <p v-else slot="value" class="car-info">请选择</p>
      </cell>
    </group>
    <group title="订购信息">
      <x-input title="预付定金" placeholder="请输入金额" v-model="buy.deposit">
        <span slot="right" class="fc-block">元</span>
      </x-input>
      <selector title="购买类型" placeholder="请选择" :options="buyType" v-model="buy.buy_type"></selector>
      <selector title="付款方式" placeholder="请选择" :options="payType" v-model="buy.pay_type"></selector>
    </group>
    <group title="提醒设置">
      <datetime title="预约到店" class="datetime" placeholder="请选择预约到店时间"
                format="YYYY-MM-DD HH:mm" year-row="{value}年" month-row="{value}月" day-row="{value}日"
                hour-row="{value}时" minute-row="{value}分" confirm-text="完成" cancel-text="取消" :min-hour="8"
                :max-hour="19" v-model="buy.next_arrive_at" :start-date="start_date" :end-date="end_date"></datetime>
      <datetime title="下次致电" class="datetime" placeholder="请选择下次致电时间"
                format="YYYY-MM-DD" year-row="{value}年" month-row="{value}月" day-row="{value}日" confirm-text="完成"
                cancel-text="取消" v-model="buy.next_contact_at" :start-date="start_date" :end-date="end_date"></datetime>
    </group>
    <group title="其他备注">
      <x-textarea placeholder="请记录你的跟进情况，不少于3个且不超过60个文字" v-model="buy.remark" :show-counter="false" :max="60"
                  class="sale-record-text"
                  ref=autosize>
      </x-textarea>
    </group>
    <section class="btn-bottom">
      <div class="btn-fix">
        <a class="btn" href="javascript:void(0);" @click.stop="toSave()">确认提交</a>
      </div>
    </section>
  </article>
</template>

<script>
import {
  Datetime,
  Selector,
  XTextarea,
  XInput,
  Cell,
  Group
} from '@lx-frontend/cvux'
import cache from '../../../common/cache'
import util from '../../../common/util'

export default {
  components: {
    Datetime,
    Selector,
    XTextarea,
    XInput,
    Cell,
    Group
  },
  data () {
    return {
      originUrl: 'originUrl',
      localDataKey: 'sureLocalData',
      start_date: null,
      end_date: null,
      buyType: [],
      payType: [],
      buy: {
        'car_mode_name': '',
        'buy_type': '1',
        'car_model_id': '',
        'customer_id': '',
        'deposit': '',
        'next_arrive_at': '',
        'next_contact_at': '',
        'pay_type': '1',
        'remark': ''
      }
    }
  },
  created () {
    this.buy.customer_id = this.$route.params.id
    this.start_date = this.futureTime(1)
    this.end_date = this.futureTime(180)
    this.$rest.saleManage.getEnums().then(res => {
      let enums = res.data
      this.buyType = enums.buy_type
      this.payType = enums.pay_type
      let data = cache.getSessionData(this.localDataKey)
      if (data && data.buy) {
        this.buy = data.buy
      }
      let modelId = this.$route.query.modelId
      if (modelId) {
        this.$rest.saleManage.getAppointedCarInfo(null, modelId).then((res) => {
          if (res.code === 0) {
            this.buy.car_model_id = modelId
            this.buy.car_mode_name = res.data.model_name
          }
        })
      }
    })
  },
  methods: {
    selModel (flag) {
      cache.setSessionData(this.originUrl, {
        from: 'sure',
        includeColor: flag,
        path: '/salemanage/staff/sure/' + this.buy.customer_id
      })
      cache.setSessionData(this.localDataKey, {
        buy: this.buy
      })
      this.$router.push('/salemanage/car/intendbrands')
    },
    futureTime (days) {
      let millSeconds = Math.abs(new Date().getTime() + (days * 24 * 60 * 60 * 1000))
      let future = new Date(millSeconds)
      let year = future.getFullYear()
      let month = future.getMonth() + 1
      if (month < 10) month = '0' + month
      let date = future.getDate()
      if (date < 10) date = '0' + date
      return (year + '-' + month + '-' + date)
    },
    toSave () {
      let buy = this.buy
      if (!buy.car_model_id) {
        this.showToast('请选择订购车型')
        return false
      }
      if (!buy.buy_type) {
        this.showToast('请选择购买类型')
        return false
      }
      if (!buy.pay_type) {
        this.showToast('请选择付款方式')
        return false
      }
      if (!buy.deposit) {
        this.showToast('请输入预付金额')
        return false
      } else if (!util.regexpMap.regexp_decimals.test(buy.deposit)) {
        this.showToast('预付定金必须为正数并且至多2位小数')
        return false
      }
      let remark = buy.remark
      if (remark === '' || remark.length < 3 || remark.length > 60) {
        this.showToast('备注信息必须为3~60个文字之间')
        return false
      }
      let transport = {
        buy_type: parseInt(buy.buy_type),
        car_model_id: parseInt(buy.car_model_id),
        customer_id: parseInt(this.buy.customer_id),
        next_arrive_at: buy.next_arrive_at,
        next_contact_at: buy.next_contact_at || null,
        pay_type: parseInt(buy.pay_type),
        remark: buy.remark,
        deposit: parseInt(this.buy.deposit * 100)
      }
      if (buy.next_arrive_at === '' || buy.next_arrive_at === null) {
        transport.next_arrive_at = null
      } else if (buy.next_arrive_at) {
        let date = new Date(buy.next_arrive_at)
        if (date.getSeconds() > 0 || buy.next_arrive_at.endsWith('00')) {
          transport.next_arrive_at = buy.next_arrive_at
        } else {
          transport.next_arrive_at = buy.next_arrive_at + ':00'
        }
      }
      this.$rest.saleManage.sureSignTheBill(transport).then(res => {
        if (res.code === 0) {
          this.showToast('提交成功')
        } else {
          this.showToast(res.message)
        }
      })
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
